
//Get diamond items
let diamond_details_popup = document.getElementById('Diamond-Details-Popup')
//let diamond_details_img = document.getElementById('Diamond-Details-Popup-Img')
let diamond_details_exit_path = document.getElementById('Diamond-Details-Popup-Exit')
let diamond_details_inner_wrapper = document.getElementById('Diamond-Details-Popup-Inner-Container-Wrapper')
let cert_btn =  document.getElementById('Diamond-Details-Popup-Info-Detail-3')
//diamond_1.addEventListener('click',()=>{openDiamondDetails()})
let document_has_loadNext_listener = false


function openDiamondDetails(diamond){
    let diamond_select = document.getElementById('Diamond-Details-Popup-Select-Diamond-Btn')
    diamond_select.innerHTML = 'ADD THIS DIAMOND'
    diamond_select.dataset.data = JSON.stringify(diamond)

    let diamond_details_img_container = document.getElementById('Diamond-Details-Popup-Img-Inner-Container-' + diamond['id'])
    cert_btn.dataset.link = 'https://www.igi.org/verify-your-report/?r=' + diamond['certificate_number']
    diamond_details_popup.style.display = 'block'
    //diamond_details_img.src = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/images/' + diamond['s3_img'] + '.jpg'
    Array.from(document.getElementById('Diamond-Details-Popup-Images').querySelectorAll('.diamond-details-popup-img-inner-container')).forEach(container=>{container.style.display = 'none'})
    diamond_details_img_container.style.display = 'block'
    document.getElementById('Diamond-Details-Popup-Info-Title').innerText = diamond['cts'] + ' Carat ' + capitalizeFirstLetter(diamond['fintensity'].toLowerCase()) + ' ' + capitalizeFirstLetter(diamond['fcolor'].toLowerCase()) + '-' + diamond['clarity'] + ' ' + capitalizeFirstLetter(diamond['shape'].toLowerCase()) + ' Shaped Diamond' 
    document.getElementById('Diamond-Details-Popup-Info-Detail-1').innerText = 'Quality: ' +capitalizeFirstLetter(diamond['fintensity'].toLowerCase()) + ' ' + capitalizeFirstLetter(diamond['fcolor'].toLowerCase()) +' | ' + diamond['clarity'] + ' Clarity'
    document.getElementById('Diamond-Details-Popup-Info-Detail-2').innerText = 'Certificate Number: ' + diamond['certificate_number'] 
    //document.getElementById('Diamond-Details-Popup-Info-Details-3') = 
    document.getElementById('Diamond-Details-Popup-Info-Detail-4').innerText = 'Description: This Certified ' + capitalizeFirstLetter(fcolor.toLowerCase()) + ' ' + capitalizeFirstLetter(diamond_shape.toLowerCase()) + ' Lab Grown Diamond has been hand selected for its exceptional rarity and characteristics'
    document.getElementById('Diamond-Details-Popup-Info-Detail-5').innerHTML = formatDiamondSelectorMoney(diamond['price'])

}





document.getElementById('Diamond-Details-Popup-Exit').addEventListener('click',()=>{
    diamond_details_popup.style.display = 'none'
})

cert_btn.addEventListener('click',()=>{
    let text = "You are about to be redirected to another page";
    if (confirm(text) == true) {
        window.open(cert_btn.dataset.link,'_blank').focus()
    }
})

function revealDetailsExitMobile(){
        diamond_details_exit_path.style.transition = ''
        diamond_details_exit_path.style.opacity = 1;
        setTimeout(()=>{
            diamond_details_exit_path.style.transition = '.5s opacity ease'
            diamond_details_exit_path.style.opacity = 0;
        },1250)
}


if(window.innerWidth < 768){
    diamond_details_inner_wrapper.addEventListener('scroll',()=>{
        revealDetailsExitMobile()
    })

}


// let diamonds = [
//     {
//     "id": "2c722d00-0c57-4f82-8fc2-d12af1f0aef7",
//     "shape": 1,
//     "cts": "0.78",
//     "fcolor": 1,
//     "fintensity": 4,
//     "clarity": 2,
//     "cut_precision": 5,
//     "certificate": 1,
//     "certificate_link": "https://api.igi.org/viewpdf.php?r=572328097",
//     "certificate_number": "572328097",
//     "measurements": "6.05mm x 6.07mm x 3.49mm",
//     "polish": 5,
//     "symmetry": 6,
//     "img": "https://view.gem360.in/gem360/2303231236-572328097/thumb.jpg",
//     "s3_img": "2c3f21c0-b1e4-4198-a58b-2a4e697c5218",
//     "video": "https://view.gem360.in/gem360/2303231236-572328097/gem360-2303231236-572328097.html",
//     "price_php": 945
//     }
// ]
//Variables
let web_server = 'https://api.luccerings.com'

let diamond_key 
let page = 1
let next_page = true
//let diamond_shape = url.searchParams.get('shape').slice(0,-4).toUpperCase()
let all_cut = false
let filter
let sort = 'carat-low'
let first_load = true
let prev_sort
let ids = ''
let exclude = ''
let fcolor
//let is_earring = url.searchParams.get('earrings')
let diamond_load_retries = 0
let diamond_load_retry_timeout
let diamond_load_retry_in_progress = false

function formatDiamondSelectorMoney(price) {
  return '<span data-lucce-convert data-lucce-php-price="' + Number(price) + '">\u20b1' + Number(price).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + '</span>';
}

function refreshDiamondSelectorCurrency() {
  [100, 500, 1200].forEach(delay => {
    window.setTimeout(() => {
      if (window.LucceCurrencyFormatter && typeof window.LucceCurrencyFormatter.refresh === 'function') {
        window.LucceCurrencyFormatter.refresh();
      }

      if (!window.bucksCC) return;

      if (typeof window.bucksCC.convert === 'function') window.bucksCC.convert();
      if (typeof window.bucksCC.convertAll === 'function') window.bucksCC.convertAll();
      if (typeof window.bucksCC.refresh === 'function') window.bucksCC.refresh();
      if (typeof window.bucksCC.update === 'function') window.bucksCC.update();
    }, delay);
  });
}

let diamond_list_count = 0
let diamond_item_size = 331
let diamond_items_per_row = 4
let diamond_list_container_margin_top = 300

let diamond_img_inner_container_width = 220

if(window.innerWidth <= 1200){
    diamond_img_inner_container_width = 250
}

if(window.innerWidth <= 768){
    diamond_img_inner_container_width = window.innerWidth * .42
}

document.getElementById('Customize-Diamond-Message-Container').style.top = document.getElementById('Customize-Grey-Divider').getBoundingClientRect().y + 40 +'px'


if(window.innerWidth <= 768){
    diamond_item_size = 265
}

//testing purposes

diamond_shape = (url.searchParams.get('shape') || '').replace(/\s*Cut\s*$/i, '').toUpperCase()

function getRequestedDiamondColor(){
  let requestedColor = (url.searchParams.get('fcolor') || '').trim().toUpperCase()
  let productName = (url.searchParams.get('name') || '').toUpperCase()
  let supportedColors = ['PINK', 'YELLOW', 'BLUE', 'GREEN']

  if(supportedColors.includes(requestedColor)){
    return requestedColor
  }

  return supportedColors.find(color=>productName.includes(color)) || ''
}

fcolor = getRequestedDiamondColor()
let diamond_color_tm
let selectedSelectorContext = (
  url.searchParams.get('design') ||
  url.searchParams.get('collection') ||
  url.searchParams.get('name') ||
  ''
).trim()

document.getElementById("Filter-Container-Title-Color").innerText = selectedSelectorContext || (
  fcolor
    ? 'Lab Grown ' + capitalizeFirstLetter(fcolor.toLowerCase()) + ' Diamonds'
    : 'Lab Grown Colored Diamonds'
)
if(fcolor == 'PINK'){
  diamond_color_tm = 'Embrace your rare romance with LUCCE ROSÉ™ Pink Lab Diamonds inspired by your one-of-a-kind love.'
} 
else if(fcolor == 'YELLOW'){
diamond_color_tm = 'Represent a radiant and captivating love with LUCCE SUNBURST™ Yellow Lab Diamonds  inspired by the sun\'s vibrance.'
}
else if(fcolor == 'BLUE'){
  diamond_color_tm = 'Celebrate ever-flowing eternal love with LUCCE OCEAN™ Blue Lab Diamonds inspired by the depths of the ocean.'
}
else if(fcolor == 'GREEN'){
  diamond_color_tm = 'Express a love intentionally grown with LUCCE VERDANT™ Green Lab Diamonds inspired by lush nature.'
}
if(!diamond_color_tm){
  diamond_color_tm = 'Discover LUCCE Colored Diamonds'
}
document.getElementById("Filter-Container-Title-TM").innerText = diamond_color_tm

//fcolor = 'PINK'
filter = '&SHAPE=' + diamond_shape + '&FCOLOR=' + fcolor

let activeColorFilter = document.getElementById('Filter-Color-' + capitalizeFirstLetter(fcolor.toLowerCase()))
if(activeColorFilter){
  activeColorFilter.classList.add('customize-filter-color-value-active')
}

//filter on load
let filter_prev = {
    'SHAPE':diamond_shape,
    'CTS_MIN':filter_values_default['CTS_MIN']/100,
    'CTS_MAX':filter_values_default['CTS_MAX']/100,
    'FCOLOR':fcolor,
    'FINTENSITY': filter_values_default['FINTENSITY'],                
    'PRICE_PHP_MIN':filter_values_default['PRICE_PHP_MIN'],
    'PRICE_PHP_MAX':filter_values_default['PRICE_PHP_MAX'],
  }

if(window.innerWidth < 992){
    diamond_items_per_row = 2
} else if (window.innerWidth < 1200){
    diamond_items_per_row = 3
}

if(window.innerWidth < 768){
    diamond_list_container_margin_top = 470
}

loadDiamondKey()


//inital diamond load
//loadNextDiamondPage(page,filter,exclude)
//diamond key
function loadDiamondKey(){
    let start = new Date()
  showDiamondLoadingSpinner()
  fetch(web_server +'/diamond_key')
  .then(resp=>resp.json())
  .then(json=>{
    diamond_key = json
    loadNextDiamondPage(page,filter,false)
  })
  .catch(err=>{
    if(diamond_load_retries < 3){
        diamond_load_retry_in_progress = true
        console.log('retrying attempt:' + (diamond_load_retries + 1))
        diamond_load_retries = diamond_load_retries + 1
        diamond_load_retry_timeout = setTimeout(()=>{
         loadDiamondKey()
         diamond_load_retry_in_progress = false
        },1000) 
      } else {
        let time_out = getLoadingTimeOut(start)
        removeDiamondLoadingSpinner(time_out)
        setTimeout(()=>{showMsg('Error loading diamonds. Please contact support.')},time_out)
      }
  })
}



function parseDiamonds(json){

    let diamonds = json['diamonds']
    let diamonds_list = []
    next_page = json['next_page']
    for(let x=0;x<diamonds.length;x++){
        let certifcate_logo_link
        if(diamond_key['certs'][String(diamonds[x]['certificate'])] == 'IGI'){
          certifcate_logo_link = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/logo_IGI.png'
        } else {
          certifcate_logo_link = 'https://cdn.shopify.com/s/files/1/0023/2878/9049/files/gia-logo.png'
        }

        diamonds_list.push({
            'id':diamonds[x]['id'],
            'shape':diamond_key['shapes'][String(diamonds[x]['shape'])],
            'cts':diamonds[x]['cts'],
            'fcolor':diamond_key['fcolors'][String(diamonds[x]['fcolor'])],
            'fintensity':diamond_key['fintensities'][String(diamonds[x]['fintensity'])],
            'clarity':diamond_key['clarities'][String(diamonds[x]['clarity'])],
            'cut_precision':diamond_key['cuts'][String(diamonds[x]['cut_precision'])],
            'certificate': diamond_key['certs'][String(diamonds[x]['certificate'])],
            'certificate_logo':certifcate_logo_link,
            'certificate_link':diamonds[x]['certificate_link'],
            'certificate_number':diamonds[x]['certificate_number'],
            'measurements':diamonds[x]['measurements'],
            'video':diamonds[x]['video'],
            'polish': diamond_key['polishes'][String(diamonds[x]['polish'])], //diamonds[x]['polish'],
            'symmetry':diamond_key['symms'][String(diamonds[x]['symmetry'])], //diamonds[x]['symmetry'],
            'price':diamonds[x]['price_php'],
            'img':diamonds[x]['img'],
            's3_img':diamonds[x]['s3_img'],
            'use_s3':json['use_s3'],

        })
    }
  
    return diamonds_list
}

//main function
function loadNextDiamondPage(page,filter,retry){

    if(next_page){
       //get start time
       let start = new Date()
        removeMsg()
        showDiamondLoadingSpinner()
        document.removeEventListener('scroll',loadNext)
        document_has_loadNext_listener = false

        fetch(web_server +'/colored_diamonds?page='+page+filter)
        .then(resp=>resp.json())
        .then(json=>parseDiamonds(json))
        .then(diamonds=>createDiamonds(diamonds))
        .then(diamond_len=>{
//get end time
      //time_out ensures load time is a minimum of 1 sec
      let time_out = getLoadingTimeOut(start)
      removeDiamondLoadingSpinner(time_out)

      //delay if needed
      return new Promise((resolve) => {
        setTimeout(() => resolve(diamond_len), time_out);
      });
        })
        .then(diamond_count=>{
            //adjust_wrapper_height(diamond_count)
            showNewDiamondItems()

            if(diamond_count == 0){
                showMsg('No Results.  Please expand you search criteria.')
              }
        })
        .catch(err=>{
            if(diamond_load_retries < 3){
                diamond_load_retry_in_progress = true
                console.log('retrying attempt:' + (diamond_load_retries + 1))
                diamond_load_retries = diamond_load_retries + 1
                diamond_load_retry_timeout = setTimeout(()=>{
                 loadNextDiamondPage(page,filter,exclude,true)
                 diamond_load_retry_in_progress = false
                },1000) 
              } else {
                let time_out = getLoadingTimeOut(start)
                removeDiamondLoadingSpinner(time_out)
                setTimeout(()=>{showMsg('Error loading diamonds. Please contact support.')},time_out)
              }
            
        })
    }
    
  }

//filter event
document.getElementById('Customize-Filter-Container').addEventListener('change',filterDiamondChange)



function filterDiamondChange(){
    //called on filter/sort change
    //get values
    next_page = true
    sort = document.getElementById('Customize-Diamond-Sort').dataset.value
    let carat_values = $( "#Slider-Range-Carat" ).slider('option','values')
    let price_values = $( "#Slider-Range-Price" ).slider('option','values')
    let fintensity = getFIntensity()
    fcolor = getFColor()
    
    // let cert
    // if(diamond_type == '1'){
    //   cert = 'GIA'
    // }
    // else if(document.getElementById('Filter-Certificate-Btn-IGI').classList.contains('filter-certificate-btn-active') ||
    // document.getElementById('Filter-Certificate-Btn-IGI-Small-Screen').classList.contains('filter-certificate-btn-active')){
    //   cert = 'IGI'
    // } else {
    //   cert = 'GIA'
    // }
    
    
    let fv = {
      'SHAPE':diamond_shape,
      'CTS_MIN':carat_values[0]/100,
      'CTS_MAX':carat_values[1]/100,
      'PRICE_PHP_MIN':price_values[0],
      'PRICE_PHP_MAX':price_values[1],
      'FCOLOR':fcolor,
      'FINTENSITY':fintensity,
    }
    
    //if filter didn't change from previous change event, just return
    if(JSON.stringify(fv) === JSON.stringify(filter_prev) && sort == prev_sort){
      return
    }
    
    //if not earring, cts_min cannot go below .5
    // if(is_earring != 'true'){
    //   if(fv['CTS_MIN'] < 0.5){
    //     fv['CTS_MIN'] = 0.5
    //   }
    // }
    
    //url parameters
    filter = '&SHAPE='+ diamond_shape +
             '&CTS_MIN=' + fv['CTS_MIN'] + 
             '&CTS_MAX=' + fv['CTS_MAX'] + 
             '&PRICE_PHP_MIN=' + fv['PRICE_PHP_MIN'] +
             '&PRICE_PHP_MAX=' + fv['PRICE_PHP_MAX'] +
             '&FCOLOR=' + fv['FCOLOR'].trim() +
             '&FINTENS=' + fv['FINTENSITY'] +
             '&SORT=' + sort
    
    exclude = ''
    
    clearDiamondList()
    page=1
    diamond_list_count = 0
    loadNextDiamondPage(page,filter,false)
    window.scrollTo(0, 0);
    
    
    prev_sort = sort
    filter_prev = {
      'SHAPE':diamond_shape,
      'CTS_MIN':carat_values[0]/100,
      'CTS_MAX':carat_values[1]/100,
      'PRICE_PHP_MIN':price_values[0],
      'PRICE_PHP_MAX':price_values[1],
      'FCOLOR':fcolor,
      'FINTENSITY':fintensity,   
      }
    
    }

function clearDiamondList(){
    //remove previous scroll eventlistener
    //document.removeEventListener("scroll",loadNext)
    
    let diamonds = Array.from(document.querySelectorAll('.diamond-item'))
    
    for(let x=diamonds.length-1; x>=0;x--){
        diamonds[x].remove()
    }
    
    }

function createDiamonds(diamonds){

    for(let x=0;x<diamonds.length;x++){
        createDiamond(diamonds[x])
    }
   
    refreshDiamondSelectorCurrency()
    return diamonds.length


}


function createDiamond(diamond){
    `<div id="Diamond-Item-1" class="diamond-item">
            <div class="diamond-img-container">
                <div class="diamond-img-inner-container">
                    <img src="https://view.gem360.in/gem360/2501231304-560225104/thumb.jpg">

                    <div class="customize-magnifiying-glass">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#3d3d3d" class="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="diamond-item-info-container">
                <span id="Diamond--Item-Price" class="diamond-item-price"><span data-lucce-convert data-lucce-php-price="1000000">\u20b11,000,000</span></span>
                <div class="diamond-item-info">
                <span class="diamond-item-info-1">
                    <span id="Diamond-Carat">3.00 Ct.</span>
                    <span id="Diamond-Intensity">Fancy Intense</span>
                </span>
                <span class="diamond-item-info-2">
                    <span id="Diamond-Shape">Round Lab Diamond</span>
                </span>
                <span id="Diamond--Item-Price" class="diamond-item-price-mobile"><span data-lucce-convert data-lucce-php-price="1000000">\u20b11,000,000</span></span>
                </div>
            </div>
        </div>
        `
    
    //create container
    let diamond_container = document.createElement('div')
    diamond_container.style.display = 'none'
    diamond_container.id = 'Diamond-Item-' + diamond['id']
    diamond_container.classList.add('diamond-item')
    diamond_container.classList.add('diamond-item-new')


    //create img container
    let diamond_img_container = document.createElement('div')
    diamond_img_container.classList.add('diamond-img-container')

    //create img inner container
    let diamond_img_inner_container = document.createElement('div')
    diamond_img_inner_container.classList.add('diamond-img-inner-container')

    //create diamond img
    let diamond_img = document.createElement('img')
    diamond_img.dataset.id = diamond['id']
    diamond_img.id = 'Img-' + diamond['id']
    // diamond_img.src = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/images/' + diamond['s3_img'] + '.jpg'
    diamond_img.src = diamond['img']

    //add img to popup
    let d_pop_img = document.createElement('img')
    d_pop_img.src = diamond['img']
    d_pop_img.classList.add('diamond-details-popup-img-inner-container-img')


    let diamond_details_popup_img_inner_container = document.createElement('div')
    diamond_details_popup_img_inner_container.classList.add('diamond-details-popup-img-inner-container')
    diamond_details_popup_img_inner_container.id = 'Diamond-Details-Popup-Img-Inner-Container-' + diamond['id']
    diamond_details_popup_img_inner_container.style.display = 'none'
    // diamond_details_popup_img_inner_container.style.backgroundImage = 'url("'+ diamond['img'] +'")'

    diamond_details_popup_img_inner_container.append(d_pop_img)

    if(diamond['video'] !== '' && diamond['video'].includes('diamx') == false){
        let diamond_details_popup_vid_btn = document.createElement('div')
        diamond_details_popup_vid_btn.classList.add('customize-diamond-details-popup-video-btn')
        diamond_details_popup_vid_btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#2c4d3c" class="bi bi-play-btn-fill" viewBox="0 0 16 16">
                <path d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2m6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
            </svg>`

        diamond_details_popup_img_inner_container.append(diamond_details_popup_vid_btn)
        diamond_details_popup_vid_btn.dataset.id = diamond['id']
        diamond_details_popup_vid_btn.dataset.vid = diamond['video']

        diamond_details_popup_vid_btn.addEventListener('click',(e)=>{
            let text = "You are about to be redirected to another page";
            if (confirm(text) == true) {
                let ele = e.target
                
                if (!ele.hasAttribute("data-vid")) {
                   ele = ele.parentElement
                }
                if (!ele.hasAttribute("data-vid")) {
                  ele = ele.parentElement
               }




                let id = ele.dataset.id
                let vid = ele.dataset.vid


              if(vid.includes('v360.diamonds')){
                window.open(vid)
              } else {
                window.open("https://api.luccerings.com/colored_videos/" + id)
              }
            }
        })
    }
  

    document.getElementById('Diamond-Details-Popup-Images').append(diamond_details_popup_img_inner_container)


    // diamond_img.onload = (e)=>{

    //     let client = e.target
    //     if(client.width > client.height){
    //         let ratio = (client.width/diamond_img_inner_container_width)

    //         let diff = (client.width/ratio) - (client.height/ratio)
    //         document.getElementById('Customize-Magnifiying-Glass-' +e.target.dataset.id).style.top = ((client.height/ratio) + (diff/2) - 36) + 'px'
    //     }        
    // }

    diamond_img.addEventListener('error',(e)=>{
        document.getElementById('Diamond-Item-' + e.target.dataset.id).classList.add('customize-display-none-important')

        let d_count =document.querySelectorAll('.diamond-item').length - document.querySelectorAll('.customize-display-none-imoprtant').length
        //adjust_wrapper_height_img_errors(d_count)
    })

    //create magnifing glass
    let diamond_magnify_glass = document.createElement('div')
    diamond_magnify_glass.id = 'Customize-Magnifiying-Glass-' + diamond['id']
    diamond_magnify_glass.classList.add('customize-magnifiying-glass')
    diamond_magnify_glass.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#3d3d3d" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>`

    //build diamond img inner
    diamond_img_inner_container.append(diamond_img)
    diamond_img_inner_container.append(diamond_magnify_glass)

    //build diamond img container
    diamond_img_container.append(diamond_img_inner_container)

    //create info container
    let diamond_info_container = document.createElement('div')
    diamond_info_container.classList.add('diamond-item-info-container')

     //create info PRICE
     let diamond_info_price = document.createElement('span')
     diamond_info_price.id = 'Diamond-Item-Price-' + diamond['id']
     diamond_info_price.classList.add('diamond-item-price')
     diamond_info_price.innerHTML = formatDiamondSelectorMoney(diamond['price'])
     

    //create info 
    let diamond_info = document.createElement('div')
    diamond_info.classList.add('diamond-item-info')


    //create info 1
    let diamond_info_1 = document.createElement('span')
    diamond_info_1.classList.add('diamond-item-info-1')

    //create info carat
    let diamond_info_carat = document.createElement('span')
    diamond_info_carat.id = 'Diamond-Carat-' + diamond['id']
    diamond_info_carat.innerText = diamond['cts'] + ' ct. '

    //create info intensity //change to color
    let diamond_info_intensity = document.createElement('span')
    diamond_info_intensity.id = 'Diamond-Intensity-' + diamond['id']
    diamond_info_intensity.innerText = capitalizeFirstLetter(fcolor.toLowerCase())

    //build info 1
    diamond_info_1.append(diamond_info_carat)
    diamond_info_1.append(diamond_info_intensity)

    //create info 2
    let diamond_info_2 = document.createElement('span')
    diamond_info_2.classList.add('diamond-item-info-2')

    //create info intensity
    let diamond_info_shape = document.createElement('span')
    diamond_info_shape.id = 'Diamond-Shape-' + diamond['id']
    diamond_info_shape.innerText = ' ' + capitalizeFirstLetter(diamond['shape'].toLowerCase()) + ' Lab Diamond'

    //build info 2
    diamond_info_2.append(diamond_info_shape)

    //create info PRICE mobile
    let diamond_info_price_mobile = document.createElement('span')
    diamond_info_price_mobile.classList.add('diamond-item-price-mobile')
    diamond_info_price_mobile.innerHTML = formatDiamondSelectorMoney(diamond['price'])

    //build diamond item info
    diamond_info.append(diamond_info_1)
    diamond_info.append(diamond_info_2)
    diamond_info.append(diamond_info_price_mobile)

    //build diamond item info container
    diamond_info_container.append(diamond_info_price)
    diamond_info_container.append(diamond_info)

    //build diamond item
    diamond_container.append(diamond_img_container)
    diamond_container.append(diamond_info_container)

    //append to diamond 
    diamond_list.append(diamond_container)

    //addlisteners
    diamond_container.addEventListener('click',()=>{openDiamondDetails(diamond)})
}

function adjust_wrapper_height(count){
    let diamond_list_count = document.querySelectorAll('.diamond-item').length - document.querySelectorAll('.customize-display-none-imoprtant').length 
    let height = Math.ceil(diamond_list_count/diamond_items_per_row) * diamond_item_size
    //nav height 58.5 + 50 additional pixels
    wrapper.style.height = (height + diamond_list_container_margin_top + 58.5 + 50) + 'px'
    document.addEventListener('scroll',loadNext)
}

setInterval(()=>{
 adjust_wrapper_height_img_errors()
},250)

function adjust_wrapper_height_img_errors(){
    let diamond_count = document.querySelectorAll('.diamond-item').length - document.querySelectorAll('.customize-display-none-important').length
    console.log(diamond_count) 
    let height = Math.ceil(diamond_count/diamond_items_per_row) * diamond_item_size
    //nav height 58.5 + 50 additional pixels

    if(wrapper.getBoundingClientRect().height != (height + diamond_list_container_margin_top + 58.5 + 50) || document_has_loadNext_listener == false){
        wrapper.style.height = (height + diamond_list_container_margin_top + 58.5 + 50) + 'px'
        document.removeEventListener("scroll",loadNext)
        document.addEventListener('scroll',loadNext)
    
    }

    
}


function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

function getFIntensity(){
    let intensities = []
    Array.from(document.querySelectorAll('.customize-filter-intensity-value')).forEach(intensity=>{
        if(intensity.classList.contains('customize-filter-intensity-value-active')){
            intensities.push(intensity.innerText.toUpperCase())
        }
    })

    if(intensities.length == 0){
        intensities = 'ALL'
    } else{
        intensities = intensities.join(',')
    }

    return intensities
}

function getFColor(){
    let fcolors = []
    Array.from(document.querySelectorAll('.customize-filter-color-value')).forEach(color=>{
        if(color.classList.contains('customize-filter-color-value-active')){
            fcolors.push(color.innerText.toUpperCase().trim())
        }
    })

    if(fcolors.length == 0){
        fcolors = fcolor || 'PINK,YELLOW,BLUE,GREEN'
    } else{
        fcolors = fcolors.join(',')
    }

    return fcolors
}

function showDiamondLoadingSpinner(){
    let ctc = document.getElementById('Customize-Loader-Container')
    if(page > 1){
        ctc.style.visibility = 'visible'
        ctc.style.top = ''
        ctc.style.bottom = '20px'
    } else {
        if(window.innerWidth <= 768){
            ctc.style.bottom = ''
            ctc.style.top = (window.innerHeight - 96 -30) + 'px'
            ctc.style.visibility = 'visible'
        } else {
            ctc.style.bottom = ''
            ctc.style.top = (window.innerHeight/2 - 48) + 'px'
            ctc.style.visibility = 'visible'
        }
    }
  }

  
  function removeDiamondLoadingSpinner(time_out){
    let ctc = document.getElementById('Customize-Loader-Container')
    setTimeout(()=>{
        ctc.style.visibility = 'hidden'
    },time_out)
  }

  function getLoadingTimeOut(start){
    let end = new Date()
    let time_out = 1000 - (end-start)
  
    if(time_out < 0){
      time_out = 0
    }
  
    return time_out
  
  }

function showNewDiamondItems(){
    let new_diamond_item = Array.from(document.querySelectorAll('.diamond-item-new'))

    new_diamond_item.forEach(item=>{
      item.style.display = 'block'
      item.classList.remove('diamond-item-new')
    })
}

function loadNext(){
    let scroll_position = (document.documentElement.scrollTop)/(document.documentElement.scrollHeight - window.innerHeight)
    if(scroll_position > .99){
        wrapper.style.height = wrapper.getBoundingClientRect().height + 70 + 'px'
        page = page + 1
        loadNextDiamondPage(page,filter,false)
        document.removeEventListener("scroll",loadNext)
        document_has_loadNext_listener = false
    }
}

function showMsg(msg){
    document.getElementById('Customize-Diamond-Message').innerText = msg
    document.getElementById('Customize-Diamond-Message-Container').style.display = 'block'
}

function removeMsg(){
    document.getElementById('Customize-Diamond-Message-Container').style.display = 'none'
}




//select diamond
document.getElementById('Diamond-Details-Popup-Select-Diamond-Btn').addEventListener('click',(e)=>{

    let btn = e.target
    let height = btn.getBoundingClientRect().height
    btn.style.height = height + 'px'
    btn.innerHTML = `<div style="visibility:visible;" class="filter-customize-loader-container">
    <div class="buy-customize-loader" title="1">
    <svg fill="#fff" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_6kVp{transform-origin:center;animation:spinner_irSm .75s infinite linear}@keyframes spinner_irSm{100%{transform:rotate(360deg)}}</style><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z" class="spinner_6kVp"/></svg>
    </div>
  </div>`

  let diamond = JSON.parse(btn.dataset.data)

  let metal = url.searchParams.get('metal')
  let size = url.searchParams.get('size')
  let engravings = url.searchParams.get('engravings')
  let handle = url.searchParams.get('handle')
  let d1 = url.searchParams.get('d1')
  let d2 = url.searchParams.get('d2')
  let d2click = url.searchParams.get('d2click')
  let earrings = url.searchParams.get('earrings')

  let d1_details
  if(d1 == 'Y'){
    d1_details = getDiamond1Details()
  } else {
    d1_details = ''
  }
  let d2_details
  if(d2 == 'Y'){
    d2_details = getDiamond2Details()
  } else {
    d2_details = ''
  }

  if(earrings == 'true'){
    //only for earrings 2 diamond selection
    let lab = url.searchParams.get('lab')
    let lab_n = url.searchParams.get('lab_numb')
  
    if(diamond['certificate'] + diamond['certificate_number'] !== lab + lab_n){
        if(d2click == 'true'){
          location.href = '/products/' + handle + '?cts2=' + diamond['cts'] +
          '&color2=' + diamond['color'] + '&clarity2=' + diamond['clarity'] +
          '&metal=' + metal + '&size=' + size +
          '&lab2=' + diamond['certificate'] + '&lab_numb2=' + diamond['certificate_number'] + 
          '&img2='+ encodeURIComponent(diamond['img']) + '&price2=' + diamond['price'] + '&selected=Y' + 
          '&id2=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings) +
          '&earrings=true&d1=' + d1 + '&d2=Y' + d1_details + '&diamond_type=' + diamond_type 
        } else {
          location.href = '/products/' + handle + '?cts=' + diamond['cts'] +
          '&color=' + diamond['color'] + '&clarity=' + diamond['clarity'] +
          '&metal=' + metal + '&size=' + size +
          '&lab=' + diamond['certificate'] + '&lab_numb=' + diamond['certificate_number'] + 
          '&img='+ encodeURIComponent(diamond['img']) + '&price=' + diamond['price'] + '&selected=Y' + 
          '&id=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings) +
          '&earrings=true&&d1=Y' + '&d2=' + d2 + d2_details + '&diamond_type=' + diamond_type 
        }
    }
    else{
      window.alert('This diamond has already been selected')
      btn.innerHTML = ""
    }
   

  } else if(all_cut){
    // //send diamond id, lab number to lucce api
    // let get_previous_items_data = await get_previous_items()
    // let existing_citems = parse_previous_items(get_previous_items_data)
    // let data = {
    //   id:diamond['id'],
    //   earrings:'N',
    //   engravings: 'N',
    //   engravings_msg:'',
    //   numb:diamond['certificate_number'],
    //   code:'1c3f96c0981de4b7f2fd4f505bd4d1493b4660c07203f786b5f133ddc9fa53eb0f6c551b',
    //   existing_items:existing_citems
    // }

    // fetch(web_server +'/create_diamond',
    //       {method: 'POST',body: JSON.stringify(data)}
    //       )
    // .then(resp=>resp.json())
    // .then(data=>{
    //   location.href = '/cart/'+ data['diamond_id'] + ':1' + data['existing_items'] + '?storefront=true'
    // })
    // .catch(err=>{
    //   btn.innerHTML = 'Error'

    //   setTimeout(()=>{
    //     btn.innerHTML = btn_original_text
    //   },1000)
    // })

  } 
  else {
    // let diamond_s3_img_url = 'https://lucce-storage.s3.ap-east-1.amazonaws.com/media/thumbnails/thumb-' + diamond['s3_img'] + '.jpg'

    //normal single diamond selection
    location.href = '/products/' + handle + '?cts=' + diamond['cts'] +
    '&color=' + diamond['fcolor'] + '&clarity=' + diamond['clarity'] +
    '&metal=' + metal + '&size=' + size +
    '&lab=' + diamond['certificate'] + '&lab_numb=' + diamond['certificate_number'] + 
    '&img='+ encodeURIComponent(diamond['img'])  + '&price=' + diamond['price'] + '&selected=Y' + 
    '&id=' + diamond['id'] + '&engravings=' + encodeURIComponent(engravings) + '&diamond_type=' + diamond_type 
  }

})


//document.getElementById('Diamond-Details-Popup-Select-Diamond-Btn').addEventListener('click',(e)=>{})

//for earrings only
function getDiamond1Details(){
  price = url.searchParams.get('price')
  let cts = url.searchParams.get('cts')
  let color = url.searchParams.get('color')
  let clarity = url.searchParams.get('clarity')
  let lab = url.searchParams.get('lab')
  let lab_n = url.searchParams.get('lab_numb')
  let img = url.searchParams.get('img')
  let id = url.searchParams.get('id')

  let params = '&cts=' + cts +
  '&color=' + color + '&clarity=' + clarity +
  '&metal=' + metal + '&size=' + size +
  '&lab=' + lab + '&lab_numb=' + lab_n + 
  '&img='+ img + '&price=' + price + 
  '&id=' + id

  return params
}

function getDiamond2Details(){
  price = url.searchParams.get('price')
  let cts = url.searchParams.get('cts')
  let color = url.searchParams.get('color')
  let clarity = url.searchParams.get('clarity')
  let lab = url.searchParams.get('lab')
  let lab_n = url.searchParams.get('lab_numb')
  let img = url.searchParams.get('img')
  let id = url.searchParams.get('id')

  let params = '&cts2=' + cts +
  '&color2=' + color + '&clarity2=' + clarity +
  '&metal=' + metal + '&size=' + size +
  '&lab2=' + lab + '&lab_numb2=' + lab_n + 
  '&img2='+ img + '&price2=' + price + 
  '&id2=' + id

  return params
}
